interface FilterValuePlaceholders {
  [field: string]: string;
}

/**
 * Filtered form fields, prevented from syncing
 * ideally we'd want this somewhere more centralised
 * to better handle updating with mock information on the
 * recipient's client to simulate changes
 */
const filter: string[] = ['yaPassword', 'ddAccountNumber', 'ddSortCode'];
const filterValuePlaceholders: FilterValuePlaceholders = {
  yaPassword: 'Password1',
  ddAccountNumber: '11111111',
  ddSortCode: '111111',
};

export { filter, filterValuePlaceholders, type FilterValuePlaceholders };
